<template>
	<div class="px-1">
		<h6 class="font-weight-medium pt-3 pb-2 pl-2  m-0 text-uppercase">
			Meu carrinho
		</h6>
		<template v-if="hasCart">
			<div v-for="(item, index) in cart" :key="item.id" class="col-md-12">
				<div id="accordion" class="mb-2">
					<div
						class="card mb-1 collapsed bg-transparent border border-1 border-white"
						data-toggle="collapse"
						:href="'#item' + item.id"
						style="cursor: pointer;"
					>
						<div :id="index" class="card-header bg-transparent">
							<span class="pb-2 h5">
								{{ item.product.name }} {{ item.variant_description | capitalize_words }} <br>
							</span>
							<p class="text-muted mb-0 font-12">
								<span class="text-center">{{ item.price | toCurrency }} X {{ item.quantity }} Un</span>
								<span
									class="float-right"
								> {{ item.total | toCurrency }}</span>
							</p>
							<p class="text-center mt-1 pb-0 mb-0">
								<a href="javascript: void(0)" class="text-small font-14 font-weight-semibold">Opções</a>
							</p>
						</div>

						<div :id="'item'+item.id" class="collapse mb-0" :aria-labelledby="index">
							<div class="card-body p-0 m-0">
								<div class="row">
									<div class="col-6">
										<p class="text-center">
											<a
												:href="vueRoute('ecommerce.product.show', item.product.slug)"
												class="btn btn-info btn-sm waves-effect waves-light"
											>
												<i class="mdi mdi-information-outline" />
											</a>
										</p>
									</div>
									<div class="col-6">
										<p class="text-center">
											<a
												href="javascript: void(0);"
												class="btn btn-danger btn-sm waves-effect waves-light"
												@click="removeItemCart(item.id, index)"
											>
												<i class="mdi mdi-close" />
											</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> <!-- end #accordions-->
			</div>
			<div class="col-md-12">
				<p class="text-center">
					Valor da compra: {{ totalCart | toCurrency }}
				</p>
			</div>
			<div class="col-md-12">
				<p class="text-center">
					Total de itens: {{ totalItemsInCart }}
				</p>
			</div>
		</template>


		<template v-else>
			<p class="text-muted font-18 text-center">
				<i class="mdi mdi-cart-off" /> Carrinho vazio
			</p>
		</template>

		<div class="p-2 mt-2">
			<!--      <a :href="vueRoute('ecommerce.product.index')" class="btn btn-blue btn-block waves-effect waves-light"><span><i-->
			<!--          class="mdi mdi-cart-outline mr-1"></i></span>Ir a lista de produtos</a>-->
			<template v-if="hasCart">
				<a
					:href="vueRoute('ecommerce.cart.index')"
					class="btn btn-blue btn-block waves-effect waves-light"
				>
					<span><i class="mdi mdi-cart-outline mr-1" /></span>
					Ver carrinho
				</a>
				<template v-if="allowCloseCart">
					<a
						:href="vueRoute('ecommerce.cart.checkout')"
						class="btn btn-success btn-block waves-effect waves-light"
					>
						<span><i class="mdi mdi-cart-arrow-down mr-1" /></span>
						Finalizar
					</a>
				</template>
				<template v-else>
					<template v-if="checkIsRequiredMinimumValue && orderMinimum > 0">
						<div class="alert alert-warning mt-2">
							<p class="mb-1">
								Falta {{ orderMinimum | toCurrency }} para atingir o valor do pedido mínimo que é
								{{ minimumValue | toCurrency }}
							</p>
						</div>
					</template>
					<template v-if="checkIsRequiredMinimumProduct && orderMinimumProduct > 0">
						<div class="alert alert-warning mt-2">
							<p class="mb-1">
								Faltam {{ orderMinimumProduct }} itens para atingir o pedido mínimo que é de
								{{ minimumProduct }} itens
							</p>
						</div>
					</template>
				</template>
				<!--				<template v-else-if="checkIsRequiredMinimumValue !== 1 && checkIsRequiredMinimumProduct !== 1">-->
				<!--					<a-->
				<!--						:href="vueRoute('ecommerce.cart.checkout')"-->
				<!--						class="btn btn-success btn-block waves-effect waves-light"-->
				<!--					>-->
				<!--						<span><i class="mdi mdi-cart-arrow-down mr-1" /></span>-->
				<!--						Finalizar-->
				<!--					</a>-->
				<!--				</template>-->
				<!--				<template-->
				<!--					v-else-if="checkIsRequiredMinimumValue && orderMinimum <= 0 && checkIsRequiredMinimumProduct"-->
				<!--				>-->
				<!--					<a-->
				<!--						:href="vueRoute('ecommerce.cart.checkout')"-->
				<!--						class="btn btn-success btn-block waves-effect waves-light"-->
				<!--					>-->
				<!--						<span><i class="mdi mdi-cart-arrow-down mr-1" /></span>-->
				<!--						Finalizar-->
				<!--					</a>-->
				<!--				</template>-->
				<!--				<template-->
				<!--					v-else-if="checkIsRequiredMinimumProduct && orderMinimumProduct <= 0 && checkIsRequiredMinimumValue"-->
				<!--				>-->
				<!--					<a-->
				<!--						:href="vueRoute('ecommerce.cart.checkout')"-->
				<!--						class="btn btn-success btn-block waves-effect waves-light"-->
				<!--					>-->
				<!--						<span><i class="mdi mdi-cart-arrow-down mr-1" /></span>-->
				<!--						Finalizar-->
				<!--					</a>-->
				<!--				</template>-->
				<!--				<template v-if="checkIsRequiredMinimumValue && orderMinimum > 0">-->
				<!--					<div class="alert alert-warning mt-2">-->
				<!--						<p class="mb-1">-->
				<!--							Falta {{ orderMinimum | toCurrency }} para atingir o valor do pedido mínimo que é-->
				<!--							{{ minimumValue | toCurrency }}-->
				<!--						</p>-->
				<!--					</div>-->
				<!--				</template>-->
				<!--				<template v-if="checkIsRequiredMinimumProduct && orderMinimumProduct > 0">-->
				<!--					<div class="alert alert-warning mt-2">-->
				<!--						<p class="mb-1">-->
				<!--							Faltam {{ orderMinimumProduct }} itens para atingir o pedido mínimo que é de-->
				<!--							{{ minimumProduct }} itens-->
				<!--						</p>-->
				<!--					</div>-->
				<!--				</template>-->
			</template>
		</div>
	</div>
</template>

<script>
export default {
    name: "CartRightBar",
    props: {
        cart: {
            required: true,
            type: Array,
        },
        minimumValue: {
            required: true,
            type: Number,
        },
        minimumProduct: {
            required: true,
            type: Number,
        },
        checkIsRequiredMinimumProduct: {
            required: true,
            type: Boolean
        },
        checkIsRequiredMinimumValue: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            isOtherUser: false,
            selectedUser: '',
        }
    },
    computed: {
        hasCart() {
            return this.cart && this.cart.length > 0;
        },
        totalCart() {
            let total = 0;

            if (this.cart) {
                total = this.cart.reduce((total, item) => {
                    return parseFloat((item.quantity * item.price).toFixed(2)) + total
                }, 0)
            }

            return total;
        },
        orderMinimum() {
            let base = parseFloat(this.minimumValue || 0);

            let value = parseFloat((base - this.totalCart).toFixed(2));

            if (isNaN(value)) {
                return 0;
            }
            return value;
        },

        totalItemsInCart() {
            let totalProducts = 0
            if (this.cart) {
                totalProducts = this.cart.reduce((total, item) => {
                    return parseInt((total + item.quantity))
                }, 0)
            }
            topBarVue.totalItemsCart = totalProducts
            // indexShop.totalItemsCart = totalProducts
            return totalProducts
        },

        orderMinimumProduct() {
            let base = parseFloat(this.minimumProduct);

            let value = parseFloat((base - this.totalItemsInCart).toFixed(2))

            if (isNaN(value)) {
                return 0
            }
            return value
        },

        allowCloseCart() {
            //Aqui vai verificar se ele ativou as 2 regras
            //nesse caso o cliente pode finalizar com uma ou com outra
            if (this.checkIsRequiredMinimumProduct && this.checkIsRequiredMinimumValue) {
                return (this.orderMinimumProduct <= 0 || this.orderMinimum <= 0);
            }

            //daqui pra frente valida somente a regra individual
            if (this.checkIsRequiredMinimumProduct) {
                return this.orderMinimumProduct <= 0;
            }

            if (this.checkIsRequiredMinimumValue) {
                return this.orderMinimum <= 0;
            }

            return true;
        }

    },
    mounted() {
        localStorage.isOtherUser === 'true' ? this.isOtherUser = true : this.isOtherUser = false
    },
    methods: {
        async removeItemCart(id, index) {
            try {
                const message = await alertConfirm({
                    url: route('api.ecommerce.cart.destroy', id)
                })

                if (message === 'confirm') {
                    this.$emit('cart-item-removed', {id, index})
                    toastSuccess('Item removido com sucesso!');
                }
            } catch (e) {
                toastError('Não foi possível remover o item do carrinho.')
                console.error(e)
            }
            topBarVue.totalItemsCart = this.totalItemsInCart
            //indexShop.totalItemsCart = this.totalItemsInCart
        },
    }
}
</script>
